import { useState } from 'react';

import { DialogTitle } from '@mui/material';
import { ESelfServeTaskStatus, ETaskId } from 'common/contracts';
import { useChecklistState } from 'state/hooks/setup-checklist.hook';

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader
} from 'components/ui/dialog';

import { VerifyBusinessFormContainer } from './Form/Container';

const SuccessHeader: React.FC = () => (
  <DialogHeader className="flex flex-col text-center my-auto">
    <DialogTitle className="!p-0 text-center my-auto text-2xl">
      Thanks!
    </DialogTitle>
    <DialogDescription className="text-base-mutedForeground font-normal text-sm mx-auto text-center">
      We’ll contact you shortly to complete verification.
    </DialogDescription>
  </DialogHeader>
);

export const VerifyBusinessModal: React.FC = () => {
  const {
    isVerifyBusinessModalOpen,
    setIsVerifyBusinessModalOpen,
    toggleChecklistExpandedState,
    setTaskStatus
  } = useChecklistState();

  const [hasSubmitted, setHasSubmitted] = useState(false);

  const handleSuccess = () => {
    setHasSubmitted(true);

    setTimeout(() => {
      handleClose();
    }, 5000);

    setTaskStatus(
      ETaskId.VERIFY_BUSINESS_CONTACT,
      ESelfServeTaskStatus.PENDING
    );
  };

  const handleClose = () => {
    setIsVerifyBusinessModalOpen(false);
    setTimeout(() => {
      setHasSubmitted(false);
    }, 500);
    toggleChecklistExpandedState(false);
  };

  return (
    <Dialog open={isVerifyBusinessModalOpen} onOpenChange={handleClose}>
      <DialogContent
        className="w-[42vw] max-w-[608px] h-[655px] px-20 py-16 bg-white z-1000 mx-auto"
        showCloseButton
      >
        {hasSubmitted ? (
          <SuccessHeader />
        ) : (
          <VerifyBusinessFormContainer onSuccess={handleSuccess} />
        )}
      </DialogContent>
    </Dialog>
  );
};
